module.exports = __webpack_public_path__ + "static/media/18-holes-shot-7.d7ca21ae.jpg";